export default {
    preloader: false,
    data: [],
    params: {
        file: null,
        validated: false,
    }
}



// WEBPACK FOOTER //
// ./src/modules/import-payment-methods-document/state.js